import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import "vant/lib/index.css";
import router from "./router";
import http from "./http";
import httpNew from "./http/indexNew";
import config from "./http/config";
import VueAwesomeSwiper from "vue-awesome-swiper";
import common from "./common/function";
import "swiper/swiper-bundle.css";
import store from "./store";

import "video.js/dist/video-js.css";

// 引入插件和语言包
import VueI18n from "vue-i18n";
// import zh from "@/i18n/langs/zh";
// import ja from "@/i18n/langs/ja";
// import ko from "@/i18n/langs/ko";
// import de from "@/i18n/langs/de";
import en from "@/i18n/langs/en";
// import es from "@/i18n/langs/es";
// import fr from "@/i18n/langs/fr";
import th from "@/i18n/langs/th";
Vue.use(VueI18n);

// 获取浏览器默认语言
const userLang = navigator.languages
  ? navigator.languages[0]
  : navigator.language;
let defaultLanguage = userLang.substring(0, 2);
// 判断浏览器默认语言不是德语、英语、西班牙语、法语的时候手动设置为英语
if (!["en", "th"].includes(defaultLanguage)) defaultLanguage = "en";
// 如果有缓存，取缓存的语言
let lang = localStorage.getItem("language") || defaultLanguage;
const i18n = new VueI18n({
  locale: lang,
  messages: {
    // zh: zh, // 中文语言包
    // ja: ja, // 日语语言包
    // ko: ko, // 韩语语言包
    // de: de, // 德语语言包
    en: en, // 英语语言包
    // es: es, // 西班牙语语言包
    // fr: fr, // 法语语言包
    th: th, // 泰语语言包
  },
  silentTranslationWarn: true,
});
localStorage.setItem("language", lang); // 最后缓存当前使用的语言

Vue.prototype.$http = http;
Vue.prototype.$httpNew = httpNew;
Vue.prototype.$config = config;
Vue.prototype.common = common;
// 语言名称
Vue.prototype.LangData = {
  de: "Deutschland",
  en: "USA",
  es: "México",
  fr: "France",
  th: "ประเทศไทย",
};
// 选择分类
Vue.prototype.ChooseData = {
  de: "Deutschland – Mädchen in der Nähe",
  en: "USA – Nearby Girls",
  es: "México – Chicas cercanas",
  fr: "France – Filles à proximité",
  th: "ประเทศไทย - สาว ๆ ใกล้เคียง",
};
// 首页弹框内容
Vue.prototype.IndexPopId = {
  en: 23,
  es: 29,
  th: 28,
};
// 酒店分类
Vue.prototype.HotelData = {
  de: 5,
  en: 6,
  es: 7,
  fr: 8,
  th: 9,
};
// 妹子分类
Vue.prototype.GoodsInfo = {
  de: 4,
  en: 3,
  es: 5,
  fr: 6,
  th: 7,
};
// 公告ID
Vue.prototype.MsgIds = {
  de: 1,
  en: 2,
  es: 3,
  fr: 4,
  th: 1015,
};
// 首页滚动通知ID
Vue.prototype.NotifyIds = {
  de: 15,
  en: 14,
  es: 19,
  fr: 22,
  th: 27,
};
// 抢单规则ID
Vue.prototype.BrushingRulesIds = {
  de: 11,
  en: 10,
  es: 17,
  fr: 20,
  th: 25,
};
// 提现规则ID
Vue.prototype.WithdrawalRulesIds = {
  de: 13,
  en: 12,
  es: 18,
  fr: 21,
  th: 26,
};
// 抢单ID
Vue.prototype.QDData = {
  de: 5,
  en: 6,
  es: 7,
  fr: 8,
  th: 9,
};
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.use(Vant);
new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
